import PropTypes from 'prop-types';
import React from 'react';
import Box from '../box/box.jsx';
import Modal from '../modal/modal.jsx';
import styles from './rb-firmware-modal.css';
import k1 from './k1.png';
import k2 from './k2.png';

const RbFirmwareModal = props => (
    <Modal
        className={styles.modalContent}
        contentLabel={'Select equipment to update firmware'}
        onRequestClose={props.onCancel}
    >
        <Box className={styles.body}>
            <Box className={styles.flexWrapper}>
                <Box className={styles.editorWrapper}>
                    <Box>
                        {props.mainBoard.map((item, index) => (
                            <div
                                className={styles.radio}
                                key={index}
                            >
                                <label>
                                    <table width="100%">
                                        <tbody>
                                            <tr>
                                                <td width="10%">
                                                    <input
                                                        defaultChecked={item.k === 'k2'}
                                                        name="board"
                                                        type="radio"
                                                        value={item.k}
                                                        onChange={props.onChangeBoard}
                                                    />
                                                </td>
                                                <td
                                                    align="center"
                                                    width="60%"
                                                >
                                                    <img src={item.k === 'k1' ? k1 : k2} />
                                                </td>
                                                <td>{item.v}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </label>
                            </div>
                        ))}
                    </Box>
                    <Box className={styles.buttonRow}>
                        <button
                            className={styles.okButton}
                            disabled={props.Okdisabled}
                            onClick={props.onOk}
                        >
                            {props.Okdisabled ? 'uploading...' : 'OK'}
                        </button>
                    </Box>
                </Box>
            </Box>
        </Box>
    </Modal>
);

RbFirmwareModal.propTypes = {
    Okdisabled: PropTypes.bool,
    mainBoard: PropTypes.arrayOf(PropTypes.object),
    onCancel: PropTypes.func.isRequired,
    onChangeBoard: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired
};

export default RbFirmwareModal;
